import { isOpportunityDeepLinkPath } from './campaign-signup-redirect'

export const COMPLIANCE_RETURN_PATH_KEY = 'compliance_return_path'

const normalizePath = (path: string): string => {
  const trimmed = path.trim()
  if (!trimmed) return ''

  const [pathnamePart, searchPart] = trimmed.split('?')
  const pathname =
    pathnamePart.endsWith('/') && pathnamePart.length > 1 ? pathnamePart.slice(0, -1) : pathnamePart

  return searchPart ? `${pathname}?${searchPart}` : pathname
}

export const buildOpportunityReturnPath = (
  slug: string,
  id: number | string,
  accessToken?: string | null,
): string => {
  const trimmedSlug = slug.trim()
  const trimmedAccess = accessToken?.trim()

  if (trimmedAccess) {
    return `/opportunity/link/${trimmedSlug}?access=${trimmedAccess}`
  }

  return `/opportunity/${trimmedSlug}/${id}`
}

export const storeComplianceReturnPath = (path: string): boolean => {
  const normalized = normalizePath(path)
  if (!normalized) return false

  const pathname = normalized.split('?')[0]
  if (!isOpportunityDeepLinkPath(pathname)) return false

  localStorage.setItem(COMPLIANCE_RETURN_PATH_KEY, normalized)
  return true
}

export const getComplianceReturnPath = (): string | null => {
  const raw = localStorage.getItem(COMPLIANCE_RETURN_PATH_KEY)?.trim()
  if (!raw) return null

  const pathname = raw.split('?')[0]
  if (!isOpportunityDeepLinkPath(pathname)) {
    clearComplianceReturnPath()
    return null
  }

  return raw
}

export const clearComplianceReturnPath = (): void => {
  localStorage.removeItem(COMPLIANCE_RETURN_PATH_KEY)
}

export const consumeComplianceReturnPath = (): string | null => {
  const path = getComplianceReturnPath()
  if (!path) return null

  clearComplianceReturnPath()
  return path
}

export const storeOpportunityComplianceReturn = (
  slug: string | undefined,
  id: number | string | undefined,
  accessToken?: string | null,
): boolean => {
  if (!slug?.trim()) return false

  if (accessToken?.trim()) {
    return storeComplianceReturnPath(buildOpportunityReturnPath(slug, id ?? 0, accessToken))
  }

  if (id === undefined || id === null || id === '') return false

  return storeComplianceReturnPath(buildOpportunityReturnPath(slug, id))
}
